import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'

const app = createApp(App)
app.use(router)
app.use(store) // Add this line to inject the Vuex store
app.mount('#app')